import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ConfiguratorResolvedTextureSetRevisionFragment = { __typename: 'ConfiguratorTextureSetRevision', displacement?: number | null, height: number, id: string, width: number, mapAssignments: Array<{ __typename: 'ConfiguratorTextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'ConfiguratorTextureSetRevisionDataObject', id: string, legacyId: number } }> };

export type ConfiguratorResolveTextureSetRevisionsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ConfiguratorResolveTextureSetRevisionsQuery = { __typename: 'Query', configuratorTextureSetRevisions: Array<{ __typename: 'ConfiguratorTextureSetRevision', displacement?: number | null, height: number, id: string, width: number, mapAssignments: Array<{ __typename: 'ConfiguratorTextureSetRevisionMapAssignment', textureType: Types.TextureType, dataObject: { __typename: 'ConfiguratorTextureSetRevisionDataObject', id: string, legacyId: number } }> }> };

export const ConfiguratorResolvedTextureSetRevisionFragmentDoc = gql`
    fragment ConfiguratorResolvedTextureSetRevision on ConfiguratorTextureSetRevision {
  displacement
  height
  id
  width
  mapAssignments {
    textureType
    dataObject {
      id
      legacyId
    }
  }
}
    `;
export const ConfiguratorResolveTextureSetRevisionsDocument = gql`
    query configuratorResolveTextureSetRevisions($ids: [ID!]!) {
  configuratorTextureSetRevisions(ids: $ids) {
    ...ConfiguratorResolvedTextureSetRevision
  }
}
    ${ConfiguratorResolvedTextureSetRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorResolveTextureSetRevisionsGQL extends Apollo.Query<ConfiguratorResolveTextureSetRevisionsQuery, ConfiguratorResolveTextureSetRevisionsQueryVariables> {
    override document = ConfiguratorResolveTextureSetRevisionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }